'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "HeaderBackContext", {
    enumerable: true,
    get: function() {
        return HeaderBackContext;
    }
});
const _getNamedContext = require("../getNamedContext");
const HeaderBackContext = (0, _getNamedContext.getNamedContext)('HeaderBackContext', undefined);

//# sourceMappingURL=HeaderBackContext.js.map
